import React from 'react';
import { COLORS, RADIUS, FONT } from '../shared/tokens';

/* Titled white panel that hosts a chart. `legend` = [{ label, color }].
   `height` sizes the chart area; children should be a ResponsiveContainer. */
export default function ChartCard({ title, subtitle, legend, height = 210, children, flex = '1 1 380px' }) {
    return (
        <div style={{
            flex, minWidth: 0, boxSizing: 'border-box',
            background: COLORS.surface, border: `1px solid ${COLORS.border}`,
            borderRadius: RADIUS.card, padding: '18px 20px',
        }}>
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontFamily: FONT, fontSize: 14, fontWeight: 700, color: COLORS.text }}>{title}</div>
                    {subtitle && <div style={{ fontFamily: FONT, fontSize: 11, color: COLORS.textDim, marginTop: 2 }}>{subtitle}</div>}
                </div>
                {legend && legend.length > 0 && (
                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                        {legend.map((l, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontFamily: FONT, fontSize: 11, color: COLORS.textDim }}>
                                <span style={{ width: 9, height: 9, borderRadius: 2, background: l.color }} />
                                {l.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div style={{ height, width: '100%' }}>
                {children}
            </div>
        </div>
    );
}
